import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BellRing, ArrowRight } from "lucide-react";

const DEFAULT_PROMPT =
  "Want us to text you the moment a record hits Due Today or Overdue? No spam, just peace of mind.";

// Marketing preview of the carrier-compliant (A2P 10DLC) opt-in.
// "Turn on Alerts" is the explicit affirmative consent action; real, consent-recording
// opt-in completes inside the app after signup.
export function SmsOptInCard({ prompt = DEFAULT_PROMPT }) {
  const [phone, setPhone] = useState("");
  const digits = phone.replace(/\D/g, "");
  const ready = digits.length === 10;

  const formatPhone = (v) => {
    const d = v.replace(/\D/g, "").slice(0, 10);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  };

  return (
    <div className="relative bg-white border border-warmborder rounded-[1.75rem] shadow-[0_30px_70px_-40px_rgba(42,36,33,0.45)] p-6 sm:p-8 max-w-xl mx-auto text-left" data-testid="sms-optin-card">
      <div className="flex items-start gap-3">
        <span className="grid place-items-center w-11 h-11 rounded-2xl bg-olive/10 text-olive shrink-0"><BellRing size={20} /></span>
        <p className="text-base sm:text-lg text-espresso leading-relaxed">{prompt}</p>
      </div>

      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <input
          type="tel"
          inputMode="tel"
          value={phone}
          onChange={(e) => setPhone(formatPhone(e.target.value))}
          placeholder="Enter your mobile number"
          data-testid="sms-optin-phone"
          className="flex-1 h-12 rounded-full border border-warmborder bg-cream/60 px-5 text-sm font-num text-espresso placeholder:text-warmmuted placeholder:font-sans focus:outline-none focus:ring-2 focus:ring-olive/40 focus:border-olive transition-all"
        />
        <Link to="/signup" className="shrink-0">
          <Button size="lg" className="w-full sm:w-auto rounded-full px-6" disabled={!ready} data-testid="sms-optin-enable">
            Turn on Alerts <ArrowRight size={16} className="ml-1" />
          </Button>
        </Link>
      </div>

      {/* A2P 10DLC compliance microcopy */}
      <p className="text-xs leading-relaxed text-warmmuted mt-4" data-testid="sms-optin-compliance">
        By enabling text alerts, you agree to receive automated account notifications about activity and
        information in your account from PaySignal at the mobile number provided. Message frequency varies.
        Msg &amp; data rates may apply. Reply <span className="font-semibold text-espresso-soft">STOP</span> to opt out,{" "}
        <span className="font-semibold text-espresso-soft">HELP</span> for help. See our{" "}
        <Link to="/sms-terms" className="underline hover:text-olive">SMS Terms</Link> and{" "}
        <Link to="/privacy" className="underline hover:text-olive">Privacy Policy</Link>. Consent is not a
        condition of using PaySignal.
      </p>
    </div>
  );
}
